import { RulesManager, type RulesManagerProps } from '@carboncopyco/editor-ui';
import type { IDynamicEditData } from '@carboncopyco/types';
import { TextCaption, TextLargeParagraph } from '@carboncopyco/ui';
import { SpotEditsManagerContent } from './SpotEditsManagerContent';

export interface SpotEditsManagerProps
  extends Pick<RulesManagerProps, 'isOpen' | 'onClose'> {
  spotEditsModifications: IDynamicEditData[];
}

export const SpotEditsManager = ({
  isOpen,
  onClose,
  spotEditsModifications,
}: SpotEditsManagerProps) => {
  const showEmptyState = !spotEditsModifications.length;

  return (
    <RulesManager
      isOpen={isOpen}
      onClose={onClose}
    >
      <RulesManager.Header>
        <div className="flex min-h-[36px] mb-5">
          <RulesManager.Header.Title label="Spot Edits" />
        </div>
      </RulesManager.Header>
      {showEmptyState ? (
        <div className="flex flex-col items-center justify-center flex-1 gap-2.5">
          <TextLargeParagraph
            label="No spot edits found"
            color="text-ds-natural-600"
          />
          <TextCaption
            label="Create a new spot edit to get started"
            color="text-ds-natural-600"
            ellipsis
          />
        </div>
      ) : (
        <RulesManager.Content>
          <SpotEditsManagerContent
            spotEditsModifications={spotEditsModifications}
          />
        </RulesManager.Content>
      )}
    </RulesManager>
  );
};
